module.exports = __webpack_public_path__ + "img/offshorly-logo.6fa5dddf.png";